import { ComponentType } from 'react';
import SendIcon from '@material-ui/icons/Send';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import StopIcon from '@material-ui/icons/Stop';
import ReplayIcon from '@material-ui/icons/Replay';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import ScheduleIcon from '@material-ui/icons/Schedule';
import NotInterestedIcon from '@material-ui/icons/NotInterested';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

export type ActionToastTone = 'success' | 'danger' | 'warning' | 'info';

export type ActionToastKind =
  | 'vm-request-submitted'
  | 'vm-request-approved'
  | 'vm-request-rejected'
  | 'vm-started'
  | 'vm-stopped'
  | 'vm-terminated'
  | 'vm-rebooted'
  | 'vm-updated'
  | 'change-requested'
  | 'extension-request-submitted'
  | 'extension-revoked'
  | 'request-cancelled'
  | 'approver-changed'
  | 'ssh-key-downloaded'
  | 'comment-posted'
  | 'image-imported'
  | 'vm-shared'
  | 'access-requested'
  | 'action-failed';

// One icon + tone per action kind — the tone drives which CSS keyframe
// animation the icon plays (see ActionToast.tsx). Every icon here is
// already used elsewhere in this app (no new icon set introduced).
export const ACTION_TOAST_KINDS: Record<
  ActionToastKind,
  { icon: ComponentType<SvgIconProps>; tone: ActionToastTone }
> = {
  'vm-request-submitted': { icon: SendIcon, tone: 'info' },
  'vm-request-approved': { icon: CheckCircleIcon, tone: 'success' },
  'vm-request-rejected': { icon: CancelIcon, tone: 'danger' },
  'vm-started': { icon: PlayArrowIcon, tone: 'success' },
  'vm-stopped': { icon: StopIcon, tone: 'warning' },
  'vm-terminated': { icon: DeleteOutlineIcon, tone: 'warning' },
  'vm-rebooted': { icon: ReplayIcon, tone: 'warning' },
  'vm-updated': { icon: CheckCircleIcon, tone: 'success' },
  'change-requested': { icon: SendIcon, tone: 'info' },
  'extension-request-submitted': { icon: ScheduleIcon, tone: 'info' },
  'extension-revoked': { icon: NotInterestedIcon, tone: 'warning' },
  'request-cancelled': { icon: NotInterestedIcon, tone: 'warning' },
  'approver-changed': { icon: SendIcon, tone: 'info' },
  'ssh-key-downloaded': { icon: VpnKeyIcon, tone: 'success' },
  'comment-posted': { icon: SendIcon, tone: 'info' },
  'image-imported': { icon: CheckCircleIcon, tone: 'success' },
  'vm-shared': { icon: CheckCircleIcon, tone: 'success' },
  'access-requested': { icon: SendIcon, tone: 'info' },
  'action-failed': { icon: ErrorOutlineIcon, tone: 'danger' },
};
